import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useTypeSafeTranslation } from '@/i18n';

type Props = {
  open: boolean;
  title?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  cancelable?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  children?: React.ReactNode[] | string;
};

const ConfirmDialog: React.FC<Props> = (props) => {
  const { t } = useTypeSafeTranslation();

  return (
    <Dialog open={props.open} onClose={props.onClose} disableEscapeKeyDown>
      <DialogTitle>{props.title || t('common.confirmTitle')}</DialogTitle>
      <DialogContent>
        {typeof props.children === 'string' ? <DialogContentText>{props.children}</DialogContentText> : props.children}
      </DialogContent>
      <DialogActions>
        {props.cancelable && (
          <Button variant="outlined" onClick={props.onCancel}>
            {props.cancelLabel || t('common.cancel')}
          </Button>
        )}
        <Button variant="contained" onClick={props.onConfirm} autoFocus>
          {props.confirmLabel || t('common.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
